export default {"src":"/_next/static/media/linkedin.0bc973be.svg","height":92,"width":92,"blurWidth":0,"blurHeight":0};